import React, { useRef, useState } from "react";

import "./NavBar.css";
import Logo from "../img/logo.png";
import CircleIcon from "../img/circle-icon.svg";
import BurgerIcon from "../img/burger.svg";
import CloseIcon from "../img/close.svg";
import ClockIcon from "../img/clock-icon.svg";
import PhoneIcon from "../img/phone-icon.svg";
import MailIcon from "../img/email-icon.svg";

import { NavLink } from "react-router-dom";
import PopupInfo from "./PopupInfo";

export default function NavBar() {
  const navRef = useRef();
  const [open, setOpen] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);

  const toggleNav = function () {
    navRef.current.classList.toggle("nav-open");
    setOpen(!open);
    closeHiddenNav();
  };

  const closeNav = function () {
    navRef.current.classList.remove("nav-open");
    setOpen(false);
    closeHiddenNav();
  };

  // Hidden Nav
  const toggleHiddenNav = (type) => {
    if (type === popupType) {
      setPopup(false);
      setPopupType(null);
    } else {
      setPopup(true);
      setPopupType(type);
    }
  };

  const closeHiddenNav = () => {
    setPopup(false);
    setPopupType(null);
  };

  return (
    <header>
      <nav>
        <div className="logo-box">
          <img className="logo-image" src={Logo} alt="Site Logo" />
          <p>
            <span>ΔΙΚΗΓΟΡΙΚΟ ΓΡΑΦΕΙΟ</span>
            <span>ΣΟΡΤΟΓΛΟΥ ΧΑΛΝΤΟΥΝ</span>
          </p>
        </div>
        <div class="hidden-nav">
          <button onClick={toggleNav}>
            <img src={open ? CloseIcon : BurgerIcon} alt="" />
          </button>
          {!open && (
            <>
              <button onClick={() => toggleHiddenNav("hours")}>
                <img src={ClockIcon} alt="" />
              </button>
              <button onClick={() => toggleHiddenNav("phone")}>
                <img src={PhoneIcon} alt="" />
              </button>
              <button onClick={() => toggleHiddenNav("mail")}>
                <img src={MailIcon} alt="" />
              </button>
              <PopupInfo
                popup={popup}
                popupType={popupType}
                closeNav={closeHiddenNav}
              />
            </>
          )}
        </div>

        <ul ref={navRef} className="nav-list">
          <li>
            <NavLink onClick={closeNav} to="/" className="nav-link">
              Αρχικη
            </NavLink>
          </li>
          <li>
            <img src={CircleIcon} alt="Golden Circle" className="nav-icon" />
          </li>
          <li>
            <NavLink
              onClick={closeNav}
              to="fields/criminal-law"
              className="nav-link"
            >
              Τομεις Δικαιου
            </NavLink>
          </li>
          <li>
            <img src={CircleIcon} alt="Golden Circle" className="nav-icon" />
          </li>
          <li>
            <NavLink onClick={closeNav} to="/" className="nav-link">
              Υποθεσεις
            </NavLink>
          </li>
          <li>
            <img src={CircleIcon} alt="Golden Circle" className="nav-icon" />
          </li>
          <li>
            <NavLink onClick={closeNav} to="about-us" className="nav-link">
              Βιογραφικο
            </NavLink>
          </li>
          <li>
            <img src={CircleIcon} alt="Golden Circle" className="nav-icon" />
          </li>
          <li>
            <NavLink onClick={closeNav} to="/publications" className="nav-link">
              Δημοσιευσεις
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}
